<template>
<div v-if="outcome" class="mt-4 grid">
<div class="col-11">
<Dropdown   v-model="outcome.type" :options="types" optionLabel="name" optionValue="code" class="p-inputtext-sm" placeholder="Etkilenecek öğe"/>

<!--inputfield-->
<template v-if="outcome.type=='inputfield'">
	<Dropdown :filter="true"  v-model="outcome.inputfield_id" :options="inputfields" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="outcomeInputfieldSelected"/>
	<template v-if="inputfield">

		<template v-if="inputfield.type=='columns'">
			<Dropdown  v-model="outcome.inputfieldcolumn_id" :options="inputfield.columns" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="inputfieldColumnSelected"/>
		</template>
		<Dropdown  v-model="outcome.execution_type" :options="inputfieldmutations" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="outcomeInputfieldExecutiontypeSelected"/>

		<template v-if="this.outcome.execution_type">
			
		<template v-if="this.outcome.execution_type=='points'">
			<InputNumber   placeholder="Sayısal değer" v-model="outcome.numerical_val" class="ml-2 p-inputtext-sm" />
		</template>


		<!-- columns,min_value,max_value-->
		<template v-else-if="this.outcome.execution_type=='columns' || this.outcome.execution_type=='min_value' || this.outcome.execution_type=='max_value' || this.outcome.execution_type=='value' ">
			
				

			<Dropdown :filter="true"  v-model="outcome.comparison_type" :options="comparison_types" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm  mt-2" />

			<template v-if="outcome.comparison_type">

			<template v-if="outcome.comparison_type=='inputfield'">

			<Dropdown :filter="true"   v-model="outcome.comparison_inputfield_id" :options="inputfields" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm"  @change="comparisonInputfieldSelected"/>

			<Dropdown :filter="true"  v-if="comparisoninputfield && comparisoninputfield.type=='columns'" v-model="outcome.comparison_inputfield_column_id" :options="comparisoninputfield.columns" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" /> 
				
			</template>


			<template v-if="outcome.comparison_type=='value'">
			<InputNumber   placeholder="Sayısal değer" v-if="inputfield.type=='number'" v-model="outcome.numerical_val" class="ml-2 p-inputtext-sm" />

			<Dropdown :filter="true"  v-model="outcome.numerical_val" v-if="inputfield.type=='number'" :options="inputfieldcolumn.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" />

			<Dropdown :filter="true"  v-model="outcome.numerical_val" v-if="inputfield.type=='select'" :options="inputfield.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" />

			</template>



			</template>		
			

			
		</template>
		<!-- columns,min_value,max_value-->

		<template v-else>
			<Dropdown  v-model="outcome.numerical_val" :options="booleanoptions" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm  mt-2"/>
		</template>
		</template>



		

		
		
	</template>
</template>
<!--inputfield-->


<!--customattribute-->
<template v-if="outcome.type=='customattribute'">
	<Dropdown :filter="true"  v-model="outcome.customattribute_id" :options="customattributes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm  mt-2" @change="outcomeCustomattributeSelected"/>
	<template v-if="customattribute">
		<span class="ml-1">değerini </span>

		<Dropdown :filter="true"  v-model="outcome.comparison_type" :options="comparison_types" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm mt-2" />

		<!-- value -->
		<template v-if="outcome.comparison_type=='value'">

		<template v-if="customattribute.type=='string' || customattribute.type=='multiselect'">
			<InputText  type="text" placeholder="Text değeri" v-model="outcome.text_val" class="ml-2 p-inputtext-sm mt-2" />
		</template>

		<template v-if="customattribute.type=='number'">
			<InputText  type="text" placeholder="Sayı değeri" v-model="outcome.numerical_val" class="ml-2 p-inputtext-sm mt-2" />
		</template>

		<template v-if="customattribute.type=='select'">
			<Dropdown :filter="true"  v-model="outcome.numerical_val" :options="customattribute.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm mt-2" />
		</template>

		<template v-if="customattribute.type=='boolean'">
			<Dropdown :filter="true"  v-model="outcome.numerical_val" :options="booleanoptions" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm mt-2" />
		</template>			
		</template>
		<!-- value -->
		<!-- input -->
		<template v-if="outcome.comparison_type=='inputfield'">
			<Dropdown :filter="true"  v-model="outcome.comparison_inputfield_id" :options="inputfields" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm mt-2" @change="comparisonInputfieldSelected"/>

			<template v-if="outcome.comparison_inputfield_id && comparisoninputfield.type=='columns'">
				<Dropdown :filter="true"  v-model="outcome.comparison_inputfield_column_id" :options="comparisoninputfield.columns" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm mt-2" />
			</template>


		</template>
		<!-- input -->

		
		
	</template>
</template>
<!--customattribute-->

<!--inputfieldsection-->
<template v-if="outcome.type=='inputfieldsection'">
	<Dropdown :filter="true"  v-model="outcome.inputfieldsection_id" :options="inputfieldsections" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm mt-2" @change="outcomeInputfieldSectionSelected"/>
	<template v-if="inputfieldsection">

		<Dropdown  v-model="outcome.execution_type" :options="inputfieldsectionmutations" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="outcomeInputfieldExecutiontypeSelected"/>

		<template v-if="this.outcome.execution_type">
			
		<template v-if="this.outcome.execution_type=='points'">
			<InputNumber   placeholder="Sayısal değer mt-2" v-model="outcome.numerical_val" class="ml-2 p-inputtext-sm" />
		</template>

		<template v-else>
			<Dropdown  v-model="outcome.numerical_val" :options="booleanoptions" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm"/>
		</template>
		</template>

		
	</template>
</template>
<!--inputfieldsection-->

<!--questionresult-->
<template v-if="outcome.type=='questionresult'">
değerini, 
<Dropdown :filter="true"  v-model="outcome.comparison_type" :options="calculation_comparison_types" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm mt-2" />

<template v-if="outcome.comparison_type">

	<template v-if="outcome.comparison_type=='customcalculation'">
	<Dropdown :filter="true"   v-model="outcome.comparison_calculation_id" :options="customcalculations" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm mt-2"  />		
	</template>
	<template v-if="outcome.comparison_type=='value'">
	<InputNumber   placeholder="Sayısal değer" v-model="outcome.numerical_val" class="ml-2 p-inputtext-sm mt-2" />
	</template>


</template>

</template>
<!--questionresult-->


<template v-if="outcome.numerical_val || outcome.numerical_val===0 || outcome.comparison_inputfield_column_id || outcome.comparison_calculation_id">
	olarak güncelle
	<Dropdown  v-model="outcome.operator" :options="conditionoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm mt-2" @change="outcomeOperatorSelected"/>
</template>







</div>
<div class="col-1">
<Button v-if="show_delete" icon="pi pi-trash"  class=" p-button-danger p-button-outlined  p-button-sm mt-2" @click="removeOutcome"/>
</div>

</div>
</template>

<script>
export default {

  name: 'Questionlistconditionoutcomeline',
  props:["outcomedata","inputfields","customattributes","inputfieldsections","customcalculations"],
  data () {
    return {
    	outcome:null,
    	inputfield:null,
    	inputfieldcolumn:null,
    	customattribute:null,
    	inputfieldsection:null,  
    	comparisoninputfield:null,  	
    	comparison_types:[
    	{name:"Soru",code:"inputfield"},
    	{name:"Tam Değer",code:"value"},
    	],   	
    	calculation_comparison_types:[
    	{name:"Özel Hesaplama",code:"customcalculation"},
    	{name:"Tam Değer",code:"value"},
    	],
    	inputfieldmutations:[
    	{name:"görünür özelliğini",code:"show_field"},
    	{name:"gerekli özelliğini",code:"is_required"},
    	{name:"boş çeçilebilir özelliğini",code:"is_nullable"},
    	{name:"boş çeçme nedeni gerekli özelliğini",code:"is_null_reason_required"},
    	{name:"kanıt iste özelliğini",code:"ask_for_evidence"},
    	{name:"kanıt gerekli özelliğini",code:"is_evindence_required"},
    	{name:"kayıt notu İste özelliğini",code:"ask_for_submission_note"},
    	{name:"kayıt notu Gerekli özelliğini",code:"submission_note_required"},
    	{name:"her işaretleme tam puan özelliğini",code:"any_submission_full_points"},
    	{name:"puanını",code:"points"},
    	{name:"minimum değerini",code:"min_value"},
    	{name:"maximum değerini",code:"max_value"},
    	{name:"değerini",code:"value"},
    	{name:"sütunlarından",code:"columns"},
    	], 	
    	inputfieldsectionmutations:[
    	{name:"görünür özelliğini",code:"show_field"},
    	{name:"puanını",code:"points"},
    	],
    	columnmutations:[
    	{name:"gerekli özelliğini",code:"is_required"},
    	{name:"puanını",code:"points"},
    	{name:"minimum değerini",code:"min_value"},
    	{name:"maximum değerini",code:"max_value"},
    	],
    	columnexecutiontypes:[
    	{name:"sabit",code:"constant"},
    	{name:"sorulardan",code:"inputfield_value"},
    	],
    	booleanoptions:[
    	{name:"Açık",code:1},
    	{name:"Kapalı",code:0},
    	],
    	conditionoperators:[
    	{name:"ve",code:"and"},
    	{name:"tamamla",code:"execute"},
    	],
    	ready_to_include:false,
    	show_delete:true,
    }
  },
  computed:{
  		types()
  		{
  			if(this.$store.state.questionlists.questionlist.multiple_calculations)
  			{
  				return [
		    	{name:"Soru",code:"inputfield"},
		    	{name:"Bölüm",code:"inputfieldsection"},
		    	{name:"Özel Nitelik",code:"customattribute"},
		    	{name:"Aşama Puanı",code:"questionresult"},
		    	]
  			}
  			return [
		    	{name:"Soru",code:"inputfield"},
		    	{name:"Bölüm",code:"inputfieldsection"},
		    	{name:"Özel Nitelik",code:"customattribute"},
		    	]
  		},
  },
  watch:{
  	outcomedata(newval)
  	{
  		console.log("watch")
  		this.resolveOutcome()
  	}
  },
  mounted()
  {
  		console.log("mounted")
  		this.resolveOutcome()
  },
  methods:{
  	inputfieldColumnSelected(data)
  	{
  		this.inputfieldcolumn = this.inputfield.columns.find(item=>item.id == data.value)
  		
  	},
  	comparisonInputfieldSelected()
  	{
  		this.comparisoninputfield  = this.inputfields.find((item)=>{return item.id == this.outcome.comparison_inputfield_id}) 
  	},
  	resolveOutcome(newval)
  	{
  		this.outcome = this.outcomedata
  		//if inputfield selected
  		if(this.outcome.type=="inputfield")
  		{
  			if(this.outcome.inputfield_id)
  			{
  				let inputfield = this.inputfields.find((item)=>{return item.id == this.outcome.inputfield_id})
	  			if(inputfield.options.length)
		    	{
		    		for(let option of inputfield.options)
				      {
				      	if(option.name.length>60)
				        {
				            option.name = option.name.substring(0, 60)+"...";
				        }
				      }
		    	}
		    	this.inputfield = inputfield
		    	if(this.outcome.inputfieldcolumn_id)
		    	{
		    		this.inputfieldcolumn = this.inputfield.columns.find(item=>item.id == this.outcome.inputfieldcolumn_id)
		    	}
		    	this.ready_to_include = true
	  			this.show_delete = true
  			}
  			if(this.outcome.comparison_inputfield_id)
  			{
  				this.comparisonInputfieldSelected()
  			}
  			
  		}
  		//if customattribute selected
  		if(this.outcome.type=="customattribute")
  		{
  			if(this.outcome.customattribute_id)
  			{
  				let customattribute = this.customattributes.find((item)=>{return item.id == this.outcome.customattribute_id})
	  			if(customattribute.options.length)
		    	{
		    		for(let option of customattribute.options)
				      {
				      	if(option.name.length>30)
				        {
				            option.name = option.name.substring(0, 30)+"...";
				        }
				      }
		    	}
		    	if(this.outcome.comparison_inputfield_id)
	  			{
	  				this.comparisonInputfieldSelected()
	  			}
		    	this.customattribute = customattribute
		    	this.ready_to_include = true
	  			this.show_delete = true

  			}
  			
  		}
  		//if customattribute selected

  		//if inputfieldsection selected
  		if(this.outcome.type=="inputfieldsection")
  		{
  			if(this.outcome.inputfieldsection_id)
  			{
  				let inputfieldsection = this.inputfieldsections.find((item)=>{return item.id == this.outcome.inputfieldsection_id})
		    	this.inputfieldsection = inputfieldsection
		    	this.ready_to_include = true
	  			this.show_delete = true

  			}
  			
  		}
  		//if inputfieldsection selected
  	},
  	outcomeInputfieldSelected()
  	{
  		let inputfield  = this.inputfields.find((item)=>{return item.id == this.outcome.inputfield_id})
    	console.log(inputfield)
    	
    	if(inputfield.options.length)
    	{
    		for(let option of inputfield.options)
		      {
		      	if(option.name.length>30)
		        {
		            option.name = option.name.substring(0, 30)+"...";
		        }
		      }
    	}    	
    	this.inputfield = inputfield
  	},
  	outcomeInputfieldSectionSelected()
  	{
  		let inputfieldsection  = this.inputfieldsections.find((item)=>{return item.id == this.outcome.inputfieldsection_id})
    	console.log(inputfieldsection)
    	
    	   	
    	this.inputfieldsection = inputfieldsection
  	},

  	
  	outcomeCustomattributeSelected()
  	{
  		let customattribute  = this.customattributes.find((item)=>{return item.id == this.outcome.customattribute_id})
    	console.log(customattribute)
    	
    	if(customattribute.options.length)
    	{
    		for(let option of customattribute.options)
		      {
		      	if(option.name.length>30)
		        {
		            option.name = option.name.substring(0, 30)+"...";
		        }
		      }
    	}    	
    	this.customattribute = customattribute
  	},
  	outcomeInputfieldExecutiontypeSelected()
  	{
  		this.outcome.numerical_val = null
  	},
  	outcomeOperatorSelected()
    {

    	this.show_delete = true
    	this.$emit("outcomeConcluded",this.outcome)
    },
    removeOutcome()
    {
    	this.$emit("removeOutcome",this.outcome)
    }

  },
}
</script>

<style lang="css" scoped>
</style>